import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errMsg, useApi } from "@/lib/api";
import { tarikh } from "@/pages/AkaunPage";

const inp = "w-full h-10 px-3 rounded-lg bg-bg border border-line text-sm focus:outline-none focus:border-[var(--q)]";
const PELAN = [["percuma", "Percuma (10 carian)"], ["asas50", "RM29/bulan — 50 carian"], ["tanpahad", "RM49/bulan — tanpa had"]];
const ymd = (d) => d.toLocaleDateString("en-CA", { timeZone: "Asia/Kuala_Lumpur" });

export const PlanDialog = ({ user, onClose, onSaved }) => {
  const api = useApi();
  const today = ymd(new Date());
  const [plan, setPlan] = useState(user.akaun.plan === "percuma" ? "tanpahad" : user.akaun.plan);
  const [mula, setMula] = useState(today);
  const [tamat, setTamat] = useState(ymd(new Date(Date.now() + 30 * 86400000)));
  const [nota, setNota] = useState("");
  const [busy, setBusy] = useState(false);
  const paid = plan !== "percuma";
  const aktif = user.akaun.plan !== "percuma" && user.akaun.plan_expires_at && new Date(user.akaun.plan_expires_at) > new Date();
  const ok = mula && mula <= today && (!paid || (tamat && tamat > mula && tamat >= today));
  const save = async () => {
    setBusy(true);
    try {
      const akaun = await api("post", `/admin/billing/users/${user.user_id}/plan`, { plan, mula, tamat: paid ? tamat : null, nota: nota.trim() });
      toast.success(`Pelan dikemas kini: ${akaun.plan_nama}`);
      onSaved(user.user_id, akaun);
      onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="plan-dialog">
        <DialogHeader><DialogTitle>Tukar pelan — {user.email}</DialogTitle></DialogHeader>
        <p className="text-sm text-mute" data-testid="plan-current">Pelan semasa: <strong className="text-ink">{user.akaun.plan_nama}</strong>{aktif && ` (tamat ${tarikh(user.akaun.plan_expires_at)})`}</p>
        <div className="space-y-3">
          <select value={plan} onChange={(e) => setPlan(e.target.value)} className={inp} data-testid="plan-select">
            {PELAN.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <div className="grid grid-cols-2 gap-3">
            <label className="text-xs text-mute space-y-1">Tarikh mula<input type="date" max={today} value={mula} onChange={(e) => setMula(e.target.value)} className={inp} data-testid="plan-mula" /></label>
            {paid && <label className="text-xs text-mute space-y-1">Tarikh tamat<input type="date" min={mula > today ? mula : today} value={tamat} onChange={(e) => setTamat(e.target.value)} className={inp} data-testid="plan-tamat" /></label>}
          </div>
          {paid && aktif && <p className="text-xs text-q" data-testid="plan-extend-note">Pengguna ada pelan aktif sehingga {tarikh(user.akaun.plan_expires_at)}. Tempoh baharu akan disambung selepas tarikh itu.</p>}
          {!paid && <p className="text-xs text-mute" data-testid="plan-free-note">Kuota bulan ini dikekalkan sehingga bulan depan.</p>}
          {mula > today && <p className="text-xs text-warn">Tarikh mula mesti hari ini atau lebih awal.</p>}
          <input value={nota} onChange={(e) => setNota(e.target.value)} maxLength={300} placeholder="Nota (pilihan)" className={inp} data-testid="plan-nota" />
          <button onClick={save} disabled={busy || !ok} data-testid="plan-save"
            className="h-10 px-5 rounded-full bg-ink text-bg text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-40">
            {busy && <Loader2 size={14} className="animate-spin" />} Simpan perubahan
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
